// removed by extract-text-webpack-plugin
module.exports = {"root":"NonLoggedBG__root___1s_5s","image":"NonLoggedBG__image___7ivVd"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/components/NonLoggedBG/NonLoggedBG.scss
// module id = 2230
// module chunks = 0